/* ZOOM BTN*/
$('.js-btn-video-zoom').on('click', function () {
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {
        $('.js-btn-video-overlay').prop('disabled', true);

        // wait for frostlines
        $('.js-btn-video-frostlines').prop('disabled', true);
    } else {
        $('.js-btn-video-overlay').prop('disabled', false);

        // wait for frostlines
        $('.js-btn-video-frostlines').prop('disabled', false);
    }

    const videoElementZoom = $('.js-video-player-zoom');
    if (!isZoomed) {
        isZoomed = true;

        videoElementZoom.addClass('active');
        $('.js-video-player .vjs-tech').addClass('opacity-0');

        zoomPlayer.currentTime = playerBase.currentTime();

        if (!playerBase.paused() && zoomPlayer.paused) {
            zoomPlayer.play();
        }
        if (playerBase.paused() && !zoomPlayer.paused) {
            zoomPlayer.pause();
        }
    } else {
        isZoomed = false;
        videoElementZoom.removeClass('active');
        $('.js-video-player .vjs-tech').removeClass('opacity-0');
    }
});

function resetVideoPlayerZoomState() {
    zoomPlayer.currentTime = 0;
    playerBase.currentTime(0);
    playerBase.pause();

    $('.js-video-player').addClass('active');
    $('.js-video-player-zoom').removeClass('active');
    $('.js-btn-video-zoom').removeClass('active');

    isZoomed = false;
}

/* FROSTLINE BTN*/
$('.js-btn-video-frostlines').on('click', function () {
    if (!isFrostlined) {
        initFrostlines();
        adjustFrostlines(playerBase.currentTime());
        showFrostlines();
        isFrostlined = true;
    }

    $(this).addClass('active');

    if ($(this).hasClass('active')) {
        $('.js-btn-video-overlay').prop('disabled', true);
        $('.js-btn-video-zoom').prop('disabled', true);
    } else {
        $('.js-btn-video-overlay').prop('disabled', false);
        $('.js-btn-video-zoom').prop('disabled', false);
    }
});

$('.js-btn-video-frostlines-reset').on('click', function (e) {
    e.stopPropagation();
    resetVideoFrostlinesState();
});

function resetVideoFrostlinesState() {
    isFrostlined = false;

    frostlinesChart.destroy();
    $('.js-frostlines-container').removeClass('active');
    $('.js-btn-video-frostlines').removeClass('active');

    $('.js-btn-video-zoom').prop('disabled', false);
    $('.js-btn-video-overlay').prop('disabled', false);

    zoomPlayer.currentTime = playerBase.currentTime();
}

/* OVERLAY BTNs*/
$('.js-btn-video-overlay').on('click', function () {
    resetVideoPlayerZoomState();
});

$('.js-btn-video-overlay-reset').on('click', function (e) {
    e.stopPropagation();
    resetVideoOverlayState();
});

function resetVideoOverlayState() {
    if (
        videojs('videoPlayerOverlay') &&
        !videojs('videoPlayerOverlay').isDisposed()
    ) {
        videojs('videoPlayerOverlay').dispose();
        playerOverlay = null;
    }

    isOverlayed = false;

    $('.js-video-overlay-select-athlete-wrapper .js-select2')
        .val(null)
        .trigger('change');
    $('.js-apply-video-overlay-select-btn').prop('disabled', true);

    $('.js-btn-video-overlay').removeClass('active');
    $('.js-video-player .vjs-tech').removeClass('opacity-05');

    $('.js-btn-video-zoom').prop('disabled', false);
    $('.js-btn-video-frostlines').prop('disabled', false);

    zoomPlayer.currentTime = playerBase.currentTime();
}
